(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4536],{

/***/ 64536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hero036": function() { return /* binding */ Hero036; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87900);
/* harmony import */ var shared_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87367);
/* harmony import */ var shared_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63414);
/* harmony import */ var _Hero036_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6371);
/* harmony import */ var _Hero036_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Hero036_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var Hero036 = function(param) {
    var payload = param.payload;
    var ref;
    var headline = (ref = payload === null || payload === void 0 ? void 0 : payload.headline) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var image = (ref1 = payload === null || payload === void 0 ? void 0 : payload.image) !== null && ref1 !== void 0 ? ref1 : {};
    var ref2;
    var videoLink = ((ref2 = payload === null || payload === void 0 ? void 0 : payload.video) !== null && ref2 !== void 0 ? ref2 : null).videoLink;
    var ref3;
    var buttonText = ((ref3 = payload === null || payload === void 0 ? void 0 : payload.video) !== null && ref3 !== void 0 ? ref3 : "").buttonText;
    var videoId = (0,shared_utils__WEBPACK_IMPORTED_MODULE_3__/* .parseYouTubeId */ .Us)(videoLink);
    var ref4 = (0,shared_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useToggle */ .OT)(), opened = ref4.opened, onOpen = ref4.onOpen, onClose = ref4.onClose;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Hero036_module_scss__WEBPACK_IMPORTED_MODULE_4___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Container */ .W2, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Hero036_module_scss__WEBPACK_IMPORTED_MODULE_4___default().content),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Heading2 */ .XJ, {
                            className: (_Hero036_module_scss__WEBPACK_IMPORTED_MODULE_4___default().headline),
                            color: "dark",
                            children: headline
                        }),
                        videoId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Action */ .aU, {
                            onClick: onOpen,
                            className: (_Hero036_module_scss__WEBPACK_IMPORTED_MODULE_4___default().play),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_Hero036_module_scss__WEBPACK_IMPORTED_MODULE_4___default().arrow),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
                                        className: (_Hero036_module_scss__WEBPACK_IMPORTED_MODULE_4___default().icon),
                                        name: "arrow_right"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Paragraph */ .nv, {
                                    color: "brand",
                                    children: buttonText
                                })
                            ]
                        }),
                        opened && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .ModalWrapper */ .AB, {
                            onCloseModal: onClose,
                            appearance: "full-area",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .YoutubeVideo */ .tL, {
                                id: videoId
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .ImageLite */ .NH, {
                    image: image,
                    className: (_Hero036_module_scss__WEBPACK_IMPORTED_MODULE_4___default().image)
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Hero036);


/***/ }),

/***/ 6371:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hero036_wrapper__TLvc_","content":"Hero036_content__86z9Y","headline":"Hero036_headline__WNBeA","image":"Hero036_image__mW2rZ","play":"Hero036_play__Q_POH","icon":"Hero036_icon__y6cu5","arrow":"Hero036_arrow__0pw4H"};

/***/ })

}]);